module.exports = __webpack_public_path__ + "img/progress.345e872d.jpg";